import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing a filter logs user view.
 * @extends JetView
 */
export default class FilterLogsUseriew extends JetView {
    /**
     * Configures the UI components of the filter logs view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('ID'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Restricts the date selection to today
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Type',
                            label: "<span class='icon-mail'></span>" + _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Tipo'),
                            options: [
                                { id: 'null', value: _('Todos') },
                                {
                                    id: '0',
                                    value: _('Inicio de sesión fallidos'),
                                },
                                {
                                    id: '1',
                                    value: _('Cambio realizado a la cuenta'),
                                },
                                { id: '2', value: _('Cuenta cancelada') },
                                { id: '3', value: _('Cuenta deshabilitada') },
                                { id: '4', value: _('Cambio de contraseña') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'IP',
                            type: 'number',
                            label: _('Dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Dirección IP'),
                        },
                        { gravity: 3, id: 'grav' }, // Placeholder for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the left filter section
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Clears the form
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue(''); // Resets the datepicker
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Removes Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Removes Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('logsUser:filter', [filterdata]); // Triggers filter event
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the second form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Gets values from second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Removes Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Removes Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('logsUser:filter', [filterdata]); // Triggers filter event
                        $$('filterPopup').hide(); // Hides the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Closes the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Displays accordion section based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hides Date if typeDate is not 2
                $$('Datepicker').show(); // Shows Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Shows Date if condition is true
                    $$('Datepicker').hide(); // Hides Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Gets current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Sets date modal configuration
        });
    }
}

// FILE DOCUMENTED
